import { linePoints } from '../../lib/chartGeometry'

type Props = {
  values: number[]
  width?: number
  height?: number
  ariaLabel?: string
}

export function Sparkline({ values, width = 88, height = 22, ariaLabel }: Props) {
  return (
    <svg
      role={ariaLabel ? 'img' : undefined}
      aria-label={ariaLabel}
      aria-hidden={ariaLabel ? undefined : true}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      height={height}
      overflow="visible"
      style={{ display: 'inline-block' }}
    >
      <polyline points={linePoints(values, width, height)} fill="none" stroke="#ffb648" strokeWidth={1.5} />
    </svg>
  )
}
